import { render, staticRenderFns } from "./notificationEmpty.vue?vue&type=template&id=14eb9248&scoped=true&"
import script from "./notificationEmpty.vue?vue&type=script&lang=js&"
export * from "./notificationEmpty.vue?vue&type=script&lang=js&"
import style0 from "./notificationEmpty.vue?vue&type=style&index=0&id=14eb9248&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eb9248",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
